var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Auth, Layout, Dependencies } from "~/core/decorator";
import { PageService } from "~/utils/page.service";
import { Action, Getter } from "vuex-class";
import { DepartmentService } from "~/services/management-service/department.service";
import { UserService } from "~/services/management-service/user.service";
import { LoginService } from "~/services/management-service/login.service";
import BatchAllotRole from "~/components/system-manage/user-manage/batch-allot-role.vue";
import AllotRole from "~/components/system-manage/user-manage/allot-role.vue";
import FacilityManage from "~/components/system-manage/user-manage/facility-manage.vue";
import DepartmentTree from "~/components/system-manage/department-tree.vue";
import ModifyUser from "~/components/system-manage/user-manage/modify-user.vue";
import AddUser from "~/components/system-manage/user-manage/add-user.vue"; // 新增用户
import AddOrganize from "~/components/system-manage/user-manage/add-organize.vue";
import ModifyOrganize from "~/components/system-manage/user-manage/modify-organize.vue";
import BatchCollectorLevel from "~/components/system-manage/user-manage/batch-collector-level.vue";
import BatchFacility from "~/components/system-manage/user-manage/batch-facility.vue";
import DataTree from "~/components/common/data-tree.vue";
var UserManage = /** @class */ (function (_super) {
    __extends(UserManage, _super);
    function UserManage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.userDataSet = [];
        _this.userModel = {
            userName: "",
            realName: "",
            userStatus: "",
            deptCode: ""
        };
        _this.userObj = {};
        _this.companyCode = "";
        _this.dialog = {
            modify: false,
            batchRole: false,
            roleAllot: false,
            facility: false,
            batchFacility: false,
            addUser: false,
            editOrganizeFlag: false,
            addOrganizeFlag: false,
            batchLevel: false
        };
        _this.editdata = {};
        _this.selectionList = [];
        _this.userList = [];
        _this.status = 0;
        _this.deptId = "";
        _this.dept = "";
        _this.defaultParams = {
            deptCode: ""
        };
        _this.pid = "";
        _this.deptCode = "";
        _this.openModel = {
            userIds: [],
            caseSwitch: ""
        };
        return _this;
    }
    UserManage.prototype.refresh = function (formName) {
        var _this = this;
        this.$nextTick(function () {
            var form = _this.$refs[formName];
            form.refresh();
        });
    };
    /**
     * 修改机构open事件(获取机构)
     */
    UserManage.prototype.getOragnize = function () {
        var _this = this;
        this.$nextTick(function () {
            var edit = _this.$refs["edit"];
            edit.refresh();
        });
    };
    /**
     * 新增用户open事件
     */
    UserManage.prototype.getdeptId = function () {
        var _this = this;
        this.$nextTick(function () {
            var dept = _this.$refs["dept"];
            dept.refresh(_this.dept);
        });
    };
    UserManage.prototype.dialogOpen = function () {
        var _this = this;
        this.$nextTick(function () {
            var addUser = _this.$refs["add-dept"];
            addUser.refresh(_this.dept);
        });
    };
    /**
     * 重置密码
     */
    UserManage.prototype.resetClick = function (scope) {
        var _this = this;
        this.$confirm("\u60A8\u786E\u5B9A\u8981\u5BF9\u7528\u6237" + scope.row.userName + "\u91CD\u7F6E\u5BC6\u7801\u5417?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
        })
            .then(function () {
            _this.userService
                .modifyUserPassword({
                userId: scope.row.id
            })
                .subscribe(function (data) {
                _this.$message.success("重置密码成功");
            });
        })
            .catch(function () {
            _this.$message({
                type: "info",
                message: "已取消重置"
            });
        });
    };
    /**
     * 批量分配角色
     */
    UserManage.prototype.batchRoleClick = function () {
        if (this.selectionList.length === 0) {
            this.$alert("请选择要分配角色的用户", "提示", {
                confirmButtonText: "确定"
            });
        }
        else {
            this.dialog.batchRole = true;
        }
    };
    /**
     * 批量设备管理
     */
    UserManage.prototype.batchDeviceManage = function () {
        if (this.selectionList.length === 0) {
            this.$message("请选择要操作的用户");
        }
        else {
            this.dialog.batchFacility = true;
        }
    };
    /**
     * 批量开启分案
     */
    UserManage.prototype.batchOpenClick = function () {
        var _this = this;
        if (this.selectionList.length === 0) {
            this.$alert("请选择要批量开启分案的用户", "提示", {
                confirmButtonText: "确定"
            });
        }
        else {
            this.openModel.userIds = this.selectionList.map(function (v) { return v.id; });
            this.openModel.caseSwitch = "ENABLED";
            this.userService.batchCaseSwitch(this.openModel).subscribe(function (data) {
                _this.$message.success("开启成功!");
                _this.refreshData();
            });
        }
    };
    /**
     * 批量关闭分案
     */
    UserManage.prototype.batchCloseClick = function () {
        var _this = this;
        if (this.selectionList.length === 0) {
            this.$alert("请选择要批量关闭分案的用户", "提示", {
                confirmButtonText: "确定"
            });
        }
        else {
            this.openModel.userIds = this.selectionList.map(function (v) { return v.id; });
            this.openModel.caseSwitch = "DISABLED";
            this.userService.batchCaseSwitch(this.openModel).subscribe(function (data) {
                _this.$message.success("关闭成功!");
                _this.refreshData();
            });
        }
    };
    /**
     * 批量更改催收员等级
     */
    UserManage.prototype.batchLevelClick = function () {
        if (this.selectionList.length === 0) {
            this.$alert("请选择要批量修改催收员等级的用户", "提示", {
                confirmButtonText: "确定"
            });
        }
        else {
            this.dialog.batchLevel = true;
        }
    };
    UserManage.prototype.refreshData = function () {
        var _this = this;
        this.userService
            .getAllUsers(this.userModel, this.pageService)
            .subscribe(function (data) {
            _this.userDataSet = data;
            _this.companyCode = data[0] ? data[0].companyCode : "";
        });
    };
    /**
     * 点击获取机构id
     */
    UserManage.prototype.onChange = function (value) {
        this.userModel.deptCode = value.deptCode;
        this.deptId = value.id;
        this.dept = value;
        this.refreshData();
    };
    UserManage.prototype.onEdit = function (value) {
        this.dialog.editOrganizeFlag = true;
        this.editdata = value;
    };
    UserManage.prototype.onAdd = function (value) {
        this.dialog.addOrganizeFlag = true;
    };
    /**
     * 移除机构
     */
    UserManage.prototype.onDelete = function (value) {
        var _this = this;
        this.$confirm("此操作将永久删除该组织机构, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
        }).then(function () {
            _this.departmentService.deleteDepartment(value.id).subscribe(function (data) {
                _this.getDepartmentList();
                _this.$message.success("删除成功!");
            });
        });
    };
    UserManage.prototype.mounted = function () {
        this.getDepartmentList();
        this.getCompanyList();
    };
    __decorate([
        Dependencies(DepartmentService)
    ], UserManage.prototype, "departmentService", void 0);
    __decorate([
        Dependencies(UserService)
    ], UserManage.prototype, "userService", void 0);
    __decorate([
        Dependencies(LoginService)
    ], UserManage.prototype, "loginService", void 0);
    __decorate([
        Dependencies(PageService)
    ], UserManage.prototype, "pageService", void 0);
    __decorate([
        Getter
    ], UserManage.prototype, "departmentData", void 0);
    __decorate([
        Action
    ], UserManage.prototype, "getDepartmentList", void 0);
    __decorate([
        Action
    ], UserManage.prototype, "getCompanyList", void 0);
    UserManage = __decorate([
        Auth(13),
        Layout("workspace"),
        Component({
            components: {
                ModifyUser: ModifyUser,
                DepartmentTree: DepartmentTree,
                FacilityManage: FacilityManage,
                AllotRole: AllotRole,
                BatchAllotRole: BatchAllotRole,
                AddUser: AddUser,
                AddOrganize: AddOrganize,
                ModifyOrganize: ModifyOrganize,
                BatchCollectorLevel: BatchCollectorLevel,
                BatchFacility: BatchFacility,
                DataTree: DataTree
            }
        })
    ], UserManage);
    return UserManage;
}(Vue));
export default UserManage;
